import * as Sentry from '@sentry/browser';
import { Angular as AngularIntegration } from '@sentry/integrations';

const dsn = "https:" + __SENTRY_SERVICE_URL__;

// Possible additions:
// 'newpassword',
    // 'oldpassword',
    // 'currentpassword',
    // 'passwordnew',
    // 'passwordrepeat',
    // 'token',
    // 'secret',
    // 'confirmationcode',
    // 'verificationcode',
    // 'iban',
    // 'bic',
    // 'accountnumber',

const SENSITIVE_KEYS = [
    'password',
    'authtoken',
];

const REDACTED = '[Filtered]';

const scrub = (input: unknown): unknown => {
    if (input === null || typeof input !== 'object') {
        return input;
    }
    if (Array.isArray(input)) {
        return input.map(scrub);
    }
    const output: Record<string, unknown> = {};
    for (const [key, value] of Object.entries(input)) {
        output[key] = SENSITIVE_KEYS.includes(key.toLowerCase()) ? REDACTED : scrub(value);
    }
    return output;
};

Sentry.init(
    {
        denyUrls: [/.+\.keendev.*/, /.*10\.10\.10\.[0-9]{1,3}.*/],
        dsn: dsn,
        integrations: [
            new AngularIntegration()
        ],
        release: `robotinterface@${__VERSION__}`,
        autoSessionTracking: false,
        tunnel: `/utils/errorreport/pui-${__IS_PROD__ ? 'live' : 'dev'}`,
        beforeSend: (event) => scrub(event) as Sentry.Event,
    }
);
